import { chakra } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';

export default chakra('div', {
  baseStyle: {
    bgColor: Color.Surface,
    borderRadius: '16px',
  },
});
